import React from "react";

class WaiseV2Boundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("[waise-v2] Interface indisponible, caisse non affectée:", error, info);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div style={{ minHeight: "100vh", background: "#01030b", color: "white", display: "grid", placeItems: "center", padding: 24 }}>
        <div style={{ width: "min(480px,100%)", padding: 24, borderRadius: 24, border: "1px solid rgba(255,184,0,.28)", background: "#081225", textAlign: "center" }}>
          <div style={{ fontSize: 36 }}>⚠️</div>
          <h1>Waise est momentanément indisponible</h1>
          <p style={{ color: "rgba(255,255,255,.65)" }}>La caisse et les ventes ne sont pas affectées. Vous pouvez retourner à MOO Sync puis réessayer plus tard.</p>
          <button type="button" onClick={() => { window.location.href = "/"; }} style={{ minHeight: 48, padding: "0 18px", border: 0, borderRadius: 14, background: "linear-gradient(135deg,#ffb800,#ff9f43)", color: "#241900", fontWeight: 800 }}>Retour à MOO Sync</button>
        </div>
      </div>
    );
  }
}

export default WaiseV2Boundary;
